<template>
  <div class="menu-footer">
    <a-menu
      class="menu-footer__content"
      mode="vertical"
      :class="{
        'menu-footer__content--collapse': collapse,
        'menu-footer__content--no-collapse': !collapse,
      }"
      @openChange="handleOpenChangePopup"
    >
      <a-sub-menu
        key="submenu-footer-first"
        class="menu-footer__submenu"
        placement="rightBottom"
        @titleClick="handleGoToProfile"
        :popupClassName="popupClassNameFooter"
        :disabled="disabled"
      >
        <menu-item-footer
          slot="title"
          :collapse="collapse"
          :names="names"
          :email="email"
          :avatar="avatar"
        />
        <template v-if="showPopup">
          <a-menu-item
            key="1"
            style="height: 302px; padding: 0; margin-top: 0"
            class="menu-footer__contain-summary"
            disabled
          >
            <summary-account
              :names="names"
              :email="email"
              :username="username"
              :phone-number="phoneNumber"
              :avatar="avatar"
              :banner="banner"
              :type-user="typeUser"
              :company-name="companyName"
              :plan-name="planName"
            />
          </a-menu-item>
          <a-menu-divider></a-menu-divider>
          <a-menu-item
            key="2"
            class="menu-footer__item"
            @click="handleGoToProfile"
          >
            Mi perfil
          </a-menu-item>
          <a-menu-divider></a-menu-divider>
          <a-sub-menu
            title="Cambiar mi estado a:"
            id="states"
            class="menu-footer__submenu--states"
            :popupClassName="popupClassNameStates"
            key="3"
          >
            <a-menu-item
              v-for="status in states"
              :key="status._id"
              :id="status.state"
              class="fix-center"
              style="display: flex; flex-direction: row; align-items: center"
              @click="showModalState(status.state)"
            >
              <a-badge
                :color="status.color"
                :text="`${
                  status.value === 'bussy' ? status.value : `En ${status.value}`
                }`"
              />
            </a-menu-item>
          </a-sub-menu>
          <a-menu-divider></a-menu-divider>
          <template v-if="isAllowedFor(profile.type, ['admin'])">
            <a-menu-item
              key="extra-4"
              class="menu-footer__item"
              @click="handleGoToSpending"
            >
              Ver mi saldo 💰
            </a-menu-item>
            <a-menu-divider></a-menu-divider>
          </template>
          <template v-if="isAllowedFor(profile.type, ['admin'])">
            <a-menu-item
              key="5"
              class="menu-footer__item"
              style="height: max-content"
            >
              <div class="menu-footer__content-item" @click="handleGoToGuide">
                Proceso de mi guía de usuario
                <a-progress
                  :percent="percentage"
                  size="small"
                  class="menu-footer__progress"
                />
              </div>
            </a-menu-item>
            <a-menu-divider></a-menu-divider>
          </template>
          <!-- Se requiere ocultar este valor sobretodo para los RI -->
          <a-menu-item
            v-if="submenu_chat_atc"
            class="menu-footer__item"
            @click="handleGoToSupport"
          >
            Chatear con atención al cliente 👩🏻‍💻
          </a-menu-item>
          <a-menu-divider></a-menu-divider>
          <a-menu-item key="6" class="menu-footer__item" @click="logout">
            Cerrar mi sesión 👋
          </a-menu-item>
        </template>
      </a-sub-menu>
      <!--menu item para q no aparezca el menu inline-->
      <a-menu-item key="" style="height: 0px; margin: 0">
        <a-icon type="" />
        <span></span>
      </a-menu-item>
    </a-menu>
    <modal-state
      :type="modalState.type"
      :visible="modalState.visible"
      :timer="timerFormatted"
      @onReconnect="handleReconnect"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import MenuItemFooter from '@/app/commons/components/molecules/MenuItemFooter'
import SummaryAccount from '@/app/commons/components/molecules/SummaryAccount'
import ModalState from '@/app/commons/components/organisms/ModalState'
import formatMixin from '@/app/shared/mixins/format'
import compareMixin from '@/app/shared/mixins/compare'
import moment from 'moment'

export default {
  name: 'MenuFooter',
  components: {
    MenuItemFooter,
    SummaryAccount,
    ModalState,
  },
  props: {
    names: { type: String, required: false, default: null },
    email: { type: String, required: false, default: null },
    companyName: { type: String, required: false, default: null },
    username: { type: String, required: false, default: null },
    phoneNumber: { type: String, required: false, default: null },
    avatar: { type: String, required: false },
    banner: { type: String, required: false },
    collapse: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, default: false },
    showPopup: { type: Boolean, default: false },
    typeUser: { type: String, required: false, default: null },
    planName: { type: String, required: false, default: null },
  },
  data: () => ({
    states: [
      { state: 'bussy', value: 'Ocupado', color: '#F5222D', _id: '1' },
      { state: 'services', value: 'Servicios', color: '#1890FF', _id: '2' },
      { state: 'training', value: 'Capacitación', color: '#FA8C16', _id: '3' },
    ],
    idStatus: null,
    timerSeconds: 0,
    timer: null, // Funcion del timer
    modalState: {
      type: null,
      visible: false,
      timer: null,
    },
  }),
  mixins: [formatMixin, compareMixin],
  mounted() {
    this.counter()
    this.handleSetModalState(this.profile)
  },
  watch: {
    profile: {
      deep: true,
      handler(nv) {
        // nv: nuevo valor
        this.handleSetModalState(nv)
      },
    },
    loggedIn() {
      if (!this.loggedIn) this.cleanData()
    },
  },
  computed: {
    ...mapGetters(['profile', 'loggedIn', 'submenu_chat_atc']),

    /**
     * Devuelve el tiempo que ha pasado en un formato de texto
     * @return {String} tiempo formateado
     */
    timerFormatted() {
      if (this.timerSeconds < 60) return `${this.timerSeconds} segundos`
      else if (this.timerSeconds < 3600)
        return `${this.timeFormatted(
          this.timerSeconds,
          'seconds',
          'toMinutes'
        )} minutos`
      else
        return `${this.timeFormatted(
          this.timerSeconds,
          'seconds',
          'toHours'
        )} horas`
    },
    /**
     * Devuelve el porcentaje de avance de guia de uusario
     * @return {Number}
     */
    percentage() {
      if (this.profile && this.isAllowedFor(this.profile.type, ['admin'])) {
        let percentage = 0
        const routes = this.profile.routes
        if (!routes) return 0
        if (routes?.createTicket.completed) percentage += 30
        if (routes?.activateChatbot.completed) percentage += 35
        if (routes?.integrateWsp.completed) percentage += 35
        else percentage += 0
        return percentage
      } else return 0
    },
    /**
     * Clase del popup footer
     */
    popupClassNameFooter() {
      const className = this.isAllowedFor(this.profile.type, ['admin'])
        ? 'menu-footer__popup--admin'
        : 'menu-footer__popup--agent'
      return `menu-footer__popup ${className}`
    },
    /**
     * Clase del popup de estados
     */
    popupClassNameStates() {
      const className = this.isAllowedFor(this.profile.type, ['admin'])
        ? 'menu-footer__popup-states--admin'
        : 'menu-footer__popup-states--agent'
      return `menu-footer__popup-states ${className}`
    },
  },
  methods: {
    ...mapActions(['saveStatusUser', 'logout', 'selectMenu', 'setAnalytics']),
    ...mapMutations(['SET_IS_OPEN_SOME_POPUP_FOOTER']),

    /** Evalúa el estado y si activar el modal de otro estado tras cargar el sidebar */
    async counter() {
      let statusObj = JSON.parse(localStorage.getItem('status'))
      switch (statusObj.status) {
        case 'bussy':
        case 'services':
        case 'training': {
          /** Setea contador de la supervision del estado y menu de la fila seleccionada */
          let diff_ms = moment(new Date()).diff(statusObj.startedIn)
          this.startTimer(Math.round(diff_ms / 1000))
        }
      }
    },
    /**
     * @param {String} status Modal que se mostrará según su estado
     */
    showModalState(status) {
      const startedIn = new Date()
      this.startTimer()
      this.saveStatusUser({ status, startedIn })
      this.idStatus = status
    },
    /**
     * Inicia la cuenta del contador
     */
    startTimer(initialTime = 0) {
      this.timerSeconds = initialTime
      this.timer = setInterval(() => {
        this.timerSeconds++
      }, 1000)
    },
    /**
     * Finaliza la cuenta del contador
     */
    stopTimer() {
      clearInterval(this.timer)
      this.timerSeconds = 0
    },
    handleReconnect() {
      this.saveStatusUser({ status: 'connected' })
      this.stopTimer()

      const divElementStatus = document.getElementById(this.idStatus)
      if (divElementStatus) {
        divElementStatus.classList.remove('ant-menu-item-selected')
      }

      const divElement = document.getElementById('statuses')
      if (divElement) {
        divElement.classList.remove('ant-menu-submenu-selected')
      }

      const divElementLogout = document.getElementById('logout')
      if (divElementLogout) {
        divElementLogout.classList.remove('ant-menu-item-selected')
      }
    },
    /**
     * Ir hacia la vista de profile
     */
    handleGoToProfile() {
      const statesElement = document.getElementById('states')
      if (statesElement)
        statesElement.classList.remove('ant-menu-submenu-selected')
      const routeName = 'profile'
      this.$router.push({ name: 'menu-user' })
      const menuItem = { route: routeName }
      this.selectMenu(menuItem)
      this.setAnalytics({ eventName: 'link_profile' })
    },
    /**
     * Limpia la data si no esta logueado
     */
    cleanData() {
      this.timer = null
      this.timerSeconds = 0
    },
    /**
     * Ir hacia la seccion de guia de usuarios
     */
    handleGoToGuide() {
      this.$router.push({ name: 'menu-guide' })
      const menuItem = { route: 'profile' }
      this.selectMenu(menuItem)
    },
    /**
     * Cambia según si el popup se encuentra abierto o no
     * @param {Array} val - es el submenu
     */
    handleOpenChangePopup(val) {
      const menuStates = document.getElementById('states')
      if (menuStates) menuStates.classList.remove('ant-menu-submenu-selected')

      const menuSelecteds = document.querySelectorAll(
        '.menu-footer__popup .ant-menu-item-selected'
      )
      if (menuSelecteds.length > 0) {
        menuSelecteds.forEach((menuSelected) => {
          menuSelected.classList.remove('ant-menu-item-selected')
        })
      }
      if (val.includes('submenu-footer-first')) {
        this.SET_IS_OPEN_SOME_POPUP_FOOTER(true)
      } else {
        this.SET_IS_OPEN_SOME_POPUP_FOOTER(false)
      }
    },
    handleSetModalState(profile) {
      if (!profile) return
      if (profile.status === 'bussy') {
        this.modalState.visible = true
        this.modalState.type = profile.status
      } else if (profile.status === 'services') {
        this.modalState.visible = true
        this.modalState.type = profile.status
      } else if (profile.status === 'training') {
        this.modalState.visible = true
        this.modalState.type = profile.status
      } else {
        this.modalState.visible = false
        this.modalState.type = profile.status
      }
    },
    handleGoToSupport() {
      window.open(`${window.location.origin}/support/`, '_blank', 'noopener')
    },
    handleGoToSpending() {
      this.$router.push({ name: 'menu-recharge-spending' })
    },
  },
}
</script>

<style lang="sass" scoped>
.menu-footer
  border-top: 1px solid $white_000
  height: 72px
  &__content
    background-color: $gray_dark_900
    border-right: 0px
    height: 72px
    display: flex
    align-items: center
    width: inherit
    &--no-collapse
      width: inherit
  &__item
    text-align: center
  &__submenu
    width: 100%
    &--states
      text-align: center
  &__contain-summary
    height: 280px
    width: 332px
    padding: 0
    margin-top: 0
    display: flex
    flex-direction: column
    align-items: center
    white-space: normal
    cursor: default
  &__content-item
    display: flex
    flex-direction: column
    align-items: center
  &__progress
    width: 70%
</style>
<style lang="sass">
.menu-footer__popup
  position: fixed!important
  &--admin
    >ul
      margin-top: -596px
  &--agent
    >ul
      margin-top: -443px
.menu-footer__popup-states
  >ul
    margin: 0
  &--admin
    top: -178px!important
  &--agent
    top: -118px!important
.menu-item-footer--no-collapse
  & + .ant-menu-submenu-arrow
    display: none
</style>
